(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-ceeattle"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const card = document.querySelector('.about-ceeattle__close[data-confetti]');
    if (!card || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const COLORS = ['#d6aedd', '#90dff9', '#fbe8a7', '#f69d25', '#e7d49d', '#e2f4fe'];
    const line = card.querySelector('.about-ceeattle__close-line');
    const canvas = document.createElement('canvas');
    canvas.className = 'about-ceeattle__confetti';
    canvas.setAttribute('aria-hidden', 'true');
    card.prepend(canvas);
    const ctx = canvas.getContext('2d');

    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    const resize = () => {
      canvas.width = card.clientWidth * dpr;
      canvas.height = card.clientHeight * dpr;
    };
    resize();
    new ResizeObserver(resize).observe(card);

    let particles = [];
    let raf = 0;
    let inView = false;
    let celebrated = false;
    let nextAmbient = Infinity;

    const spawn = (x, y, count, power) => {
      for (let i = 0; i < count; i += 1) {
        const angle = Math.random() * Math.PI * 2;
        const speed = (1.5 + Math.random() * power) * dpr;
        particles.push({
          x: x * dpr,
          y: y * dpr,
          vx: Math.cos(angle) * speed,
          vy: Math.sin(angle) * speed - 1.2 * dpr,
          gravity: 0.055 * dpr,
          drag: 0.986,
          width: (2.5 + Math.random() * 3.5) * dpr,
          height: (5 + Math.random() * 5) * dpr,
          rotation: Math.random() * Math.PI,
          spin: (Math.random() - 0.5) * 0.28,
          age: 0,
          ttl: 70 + Math.random() * 55,
          color: COLORS[(Math.random() * COLORS.length) | 0],
        });
      }
      if (!raf) raf = requestAnimationFrame(tick);
    };

    const randomBurst = () => {
      spawn(
        card.clientWidth * (0.1 + Math.random() * 0.8),
        card.clientHeight * (0.08 + Math.random() * 0.45),
        24,
        3.6
      );
    };

    const volley = () => {
      [0.18, 0.5, 0.82, 0.32, 0.68].forEach((fx, i) => {
        setTimeout(() => {
          spawn(card.clientWidth * fx, card.clientHeight * (0.12 + Math.random() * 0.3), 32, 4.5);
        }, i * 170);
      });
    };

    const celebrate = () => {
      if (celebrated) return;
      celebrated = true;
      volley();
      nextAmbient = performance.now() + 3400;
    };

    const tick = (t) => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      particles = particles.filter((p) => p.age < p.ttl);
      for (const p of particles) {
        p.age += 1;
        p.vx *= p.drag;
        p.vy = p.vy * p.drag + p.gravity;
        p.x += p.vx;
        p.y += p.vy;
        p.rotation += p.spin;
        ctx.globalAlpha = 1 - p.age / p.ttl;
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rotation);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.width / 2, -p.height / 2, p.width, p.height);
        ctx.restore();
      }
      ctx.globalAlpha = 1;
      if (inView && celebrated && t > nextAmbient) {
        randomBurst();
        nextAmbient = t + 2800 + Math.random() * 2200;
      }
      if (particles.length || inView) {
        raf = requestAnimationFrame(tick);
      } else {
        raf = 0;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
      }
    };

    card.classList.add('confetti-armed');
    if (line) {
      line.addEventListener('transitionend', (event) => {
        if (event.propertyName === 'letter-spacing') celebrate();
      });
    }

    new IntersectionObserver(
      (entries) => {
        inView = entries[0].isIntersecting;
        if (!inView) return;
        card.classList.add('confetti-closed');
        if (celebrated) nextAmbient = performance.now() + 1200;
        setTimeout(celebrate, 1400);
        if (!raf) raf = requestAnimationFrame(tick);
      },
      { threshold: 0.4 }
    ).observe(card);

    card.addEventListener('pointerdown', (event) => {
      const rect = card.getBoundingClientRect();
      spawn(event.clientX - rect.left, event.clientY - rect.top, 30, 4.2);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-studio"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const composer = document.querySelector('.contact-studio__composer');
    if (!composer) return;

    const errorPill = composer.querySelector('.contact-studio__error');
    const fields = composer.querySelectorAll('input[required], select[required], textarea[required]');

    composer.addEventListener('submit', (event) => {
      let valid = true;
      fields.forEach((field) => {
        const ok = field.checkValidity();
        field.classList.toggle('is-missing', !ok);
        if (!ok) valid = false;
      });
      if (!valid) {
        event.preventDefault();
        if (errorPill) errorPill.classList.add('is-visible');
      }
    });

    fields.forEach((field) => {
      field.addEventListener('input', () => {
        if (field.checkValidity()) field.classList.remove('is-missing');
        const anyMissing = Array.from(fields).some((f) => f.classList.contains('is-missing'));
        if (!anyMissing && errorPill && !errorPill.dataset.server) {
          errorPill.classList.remove('is-visible');
        }
      });
    });

    // Format the mobile number as (xxx) xxx-xxxx while typing
    const phone = composer.querySelector('input[type="tel"]');
    if (phone) {
      phone.addEventListener('input', (event) => {
        if (event.inputType && event.inputType.startsWith('delete')) return;
        let digits = phone.value.replace(/\D/g, '');
        if (digits.length === 11 && digits.startsWith('1')) digits = digits.slice(1);
        digits = digits.slice(0, 10);
        let formatted = digits;
        if (digits.length > 6) {
          formatted = '(' + digits.slice(0, 3) + ') ' + digits.slice(3, 6) + '-' + digits.slice(6);
        } else if (digits.length > 3) {
          formatted = '(' + digits.slice(0, 3) + ') ' + digits.slice(3);
        } else if (digits.length > 0) {
          formatted = '(' + digits;
        }
        phone.value = formatted;
      });
    }

    // Focus the first field when arriving via the Send a message link
    document.querySelectorAll('a[href="#new-message"]').forEach((link) => {
      link.addEventListener('click', () => {
        setTimeout(() => {
          const first = composer.querySelector('input');
          if (first) first.focus({ preventScroll: true });
        }, 350);
      });
    });

    // After a successful post, bring the confirmation into view and clean
    // the URL so a refresh serves a fresh form instead of this state again
    const sent = document.querySelector('.contact-studio__sent');
    if (sent) {
      sent.scrollIntoView({ block: 'center' });
      window.history.replaceState(null, '', window.location.pathname);
    }

    // Message sent: the composer celebrates, same confetti as the About
    // page closing card
    if (!sent || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const COLORS = ['#d6aedd', '#90dff9', '#fbe8a7', '#f69d25', '#e7d49d', '#e2f4fe'];
    const canvas = document.createElement('canvas');
    canvas.className = 'contact-studio__confetti';
    canvas.setAttribute('aria-hidden', 'true');
    composer.prepend(canvas);
    const ctx = canvas.getContext('2d');

    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    const resize = () => {
      canvas.width = composer.clientWidth * dpr;
      canvas.height = composer.clientHeight * dpr;
    };
    resize();
    new ResizeObserver(resize).observe(composer);

    let particles = [];
    let raf = 0;
    let inView = false;
    let nextAmbient = 0;

    const spawn = (x, y, count, power) => {
      for (let i = 0; i < count; i += 1) {
        const angle = Math.random() * Math.PI * 2;
        const speed = (1.5 + Math.random() * power) * dpr;
        particles.push({
          x: x * dpr,
          y: y * dpr,
          vx: Math.cos(angle) * speed,
          vy: Math.sin(angle) * speed - 1.2 * dpr,
          gravity: 0.055 * dpr,
          drag: 0.986,
          width: (2.5 + Math.random() * 3.5) * dpr,
          height: (5 + Math.random() * 5) * dpr,
          rotation: Math.random() * Math.PI,
          spin: (Math.random() - 0.5) * 0.28,
          age: 0,
          ttl: 70 + Math.random() * 55,
          color: COLORS[(Math.random() * COLORS.length) | 0],
        });
      }
      if (!raf) raf = requestAnimationFrame(tick);
    };

    const randomBurst = () => {
      spawn(
        composer.clientWidth * (0.1 + Math.random() * 0.8),
        composer.clientHeight * (0.08 + Math.random() * 0.45),
        24,
        3.6
      );
    };

    const tick = (t) => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      particles = particles.filter((p) => p.age < p.ttl);
      for (const p of particles) {
        p.age += 1;
        p.vx *= p.drag;
        p.vy = p.vy * p.drag + p.gravity;
        p.x += p.vx;
        p.y += p.vy;
        p.rotation += p.spin;
        ctx.globalAlpha = 1 - p.age / p.ttl;
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rotation);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.width / 2, -p.height / 2, p.width, p.height);
        ctx.restore();
      }
      ctx.globalAlpha = 1;
      if (inView && t > nextAmbient) {
        randomBurst();
        nextAmbient = t + 2800 + Math.random() * 2200;
      }
      if (particles.length || inView) {
        raf = requestAnimationFrame(tick);
      } else {
        raf = 0;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
      }
    };

    // Opening volley the moment the sent state is on screen
    [0.18, 0.5, 0.82, 0.32, 0.68].forEach((fx, i) => {
      setTimeout(() => {
        spawn(composer.clientWidth * fx, composer.clientHeight * (0.12 + Math.random() * 0.3), 32, 4.5);
      }, 300 + i * 170);
    });
    nextAmbient = performance.now() + 3400;

    new IntersectionObserver(
      (entries) => {
        inView = entries[0].isIntersecting;
        if (inView && !raf) raf = requestAnimationFrame(tick);
      },
      { threshold: 0.3 }
    ).observe(composer);

    // The message is already sent, so clicking around the card is play
    composer.addEventListener('pointerdown', (event) => {
      const rect = composer.getBoundingClientRect();
      spawn(event.clientX - rect.left, event.clientY - rect.top, 30, 4.2);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Sticky sidebar: pin by the top under the header when it fits the
    // viewport, otherwise pin by the bottom so its last rows stay reachable
    document.querySelectorAll('.cs__side').forEach((side) => {
      const place = () => {
        const headerH = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-group-height')) || 0;
        const gap = 24;
        const fitsTop = headerH + gap;
        const bottomPinned = window.innerHeight - side.offsetHeight - gap;
        side.style.setProperty('--cs-sticky-top', Math.min(fitsTop, bottomPinned) + 'px');
      };
      place();
      window.addEventListener('resize', place);
      if ('ResizeObserver' in window) new ResizeObserver(place).observe(side);
    });

    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target.closest('[data-cs-copy]') : null;
      if (!(target instanceof HTMLElement)) return;
      const url = target.dataset.csCopy || window.location.href;
      const label = target.textContent;
      const done = () => {
        if (!target.dataset.csCopied) return;
        target.textContent = target.dataset.csCopied;
        window.setTimeout(() => { target.textContent = label; }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done).catch(() => window.prompt('', url));
      } else {
        window.prompt('', url);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["event-registration"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const forms = document.querySelectorAll('.evt-form');
    if (!forms.length) return;

    const readCookie = (name) => {
      const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
      return match ? decodeURIComponent(match[1]) : null;
    };

    forms.forEach((form) => {
      const body = form.querySelector('.evt-form__body');
      const success = form.querySelector('.evt-form__success');
      const errorPill = form.querySelector('.evt-form__error');
      const errorText = form.querySelector('.evt-form__error-text');
      const submit = form.querySelector('.evt-form__submit');
      const required = () => Array.from(form.querySelectorAll('input[required], select[required]'));

      const showError = (message) => {
        if (!errorPill) return;
        if (errorText && message) errorText.textContent = message;
        errorPill.classList.add('is-visible');
      };
      const hideError = () => {
        if (!errorPill) return;
        errorPill.classList.remove('is-visible');
        if (errorText) errorText.textContent = form.dataset.errorText || '';
      };

      const validate = () => {
        let first = null;
        required().forEach((field) => {
          const ok = field.checkValidity();
          field.classList.toggle('is-missing', !ok);
          if (!ok && !first) first = field;
        });
        return first;
      };

      const onFieldActivity = (event) => {
        const field = event.target;
        if (field.classList && field.classList.contains('is-missing') && field.checkValidity()) {
          field.classList.remove('is-missing');
        }
        if (!required().some((f) => f.classList.contains('is-missing'))) hideError();
      };
      form.addEventListener('input', onFieldActivity);
      form.addEventListener('change', onFieldActivity);

      // A Shopify bounce (native route rejected) redirects back with the fields
      // echoed in the URL and renders its message server-side. Show it once,
      // then clean the URL so a reload or a reopened tab starts fresh.
      if (/[?&]form_type=contact/.test(window.location.search)) {
        window.history.replaceState(null, '', window.location.pathname);
      }

      // Phone formats as (xxx) xxx-xxxx while typing
      const phone = form.querySelector('input[type="tel"]');
      if (phone) {
        phone.addEventListener('input', (event) => {
          if (event.inputType && event.inputType.startsWith('delete')) return;
          let digits = phone.value.replace(/\D/g, '');
          if (digits.length > 10 && digits.startsWith('1')) digits = digits.slice(1);
          if (digits.length > 10) return;
          let formatted = digits;
          if (digits.length > 6) {
            formatted = '(' + digits.slice(0, 3) + ') ' + digits.slice(3, 6) + '-' + digits.slice(6);
          } else if (digits.length > 3) {
            formatted = '(' + digits.slice(0, 3) + ') ' + digits.slice(3);
          } else if (digits.length > 0) {
            formatted = '(' + digits;
          }
          phone.value = formatted;
        });
      }

      // Shopify's native /contact route requires contact[body]; compose a readable
      // summary of every answer (also what you receive when HubSpot is unavailable)
      const composeBody = (prefix) => {
        const bodyField = form.querySelector('[data-evt-body]');
        if (!bodyField) return;
        const lines = [prefix ? prefix + ' ' + (bodyField.defaultValue || 'Event registration') : (bodyField.defaultValue || 'Event registration'), ''];
        const seen = {};
        form.querySelectorAll('input, select, textarea').forEach((el) => {
          if (!el.name || el.type === 'hidden' || el.type === 'submit') return;
          const label = el.name.replace(/^contact\[/, '').replace(/\]\[\]$|\]$/, '');
          if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
          const value = (el.value || '').trim();
          if (!value) return;
          if (seen[label]) { seen[label] += ', ' + value; } else { seen[label] = value; }
        });
        Object.keys(seen).forEach((label) => lines.push(label + ': ' + seen[label]));
        bodyField.value = lines.join('\n');
      };

      // Keep answers through an accidental refresh (cleared once a submission lands)
      const draftKey = 'evt-draft-' + (form.id || 'form');
      const saveDraft = () => {
        try {
          const data = {};
          form.querySelectorAll('input, select, textarea').forEach((el) => {
            if (!el.name || el.type === 'hidden' || el.type === 'submit') return;
            if (el.type === 'checkbox' || el.type === 'radio') {
              if (el.checked) data[el.name + '=' + el.value] = true;
            } else if (el.value) {
              data[el.name] = el.value;
            }
          });
          window.sessionStorage.setItem(draftKey, JSON.stringify(data));
        } catch (e) { /* storage unavailable */ }
      };
      const restoreDraft = () => {
        try {
          const raw = window.sessionStorage.getItem(draftKey);
          if (!raw) return;
          const data = JSON.parse(raw);
          form.querySelectorAll('input, select, textarea').forEach((el) => {
            if (!el.name || el.type === 'hidden' || el.type === 'submit') return;
            if (el.type === 'checkbox' || el.type === 'radio') {
              if (data[el.name + '=' + el.value]) el.checked = true;
            } else if (data[el.name] && !el.value) {
              el.value = data[el.name];
            }
          });
        } catch (e) { /* ignore */ }
      };
      const clearDraft = () => { try { window.sessionStorage.removeItem(draftKey); } catch (e) { /* ignore */ } };
      restoreDraft();
      form.addEventListener('change', saveDraft);
      form.addEventListener('input', saveDraft);

      // Shopify's /contact rejects array fields (contact[x][] -> "x is invalid"),
      // so for the native route collapse each multi-checkbox group into one flat
      // comma-separated field and keep the originals out of the post
      const flattenMultiForNative = () => {
        const groups = {};
        form.querySelectorAll('[data-hs-multi]').forEach((el) => {
          const base = el.name.replace(/\[\]$/, '');
          if (!groups[base]) groups[base] = [];
          if (el.checked) groups[base].push(el.value);
          el.disabled = true;
        });
        Object.keys(groups).forEach((base) => {
          let flat = form.querySelector('input[type="hidden"][name="' + base.replace(/"/g, '\\"') + '"]');
          if (!flat) {
            flat = document.createElement('input');
            flat.type = 'hidden';
            flat.name = base;
            form.appendChild(flat);
          }
          flat.value = groups[base].join(', ');
        });
      };
      const prepareNative = (prefix) => {
        composeBody(prefix);
        flattenMultiForNative();
        clearDraft();
      };

      // Backup route: HubSpot unreachable or erroring -> post the same form through
      // Shopify's native contact email so no registration is lost. The registrant
      // still lands on the thank-you page; the email is flagged as a backup copy.
      const nativeBackup = (reason) => {
        console.warn('[event-registration] HubSpot unavailable, sending backup copy by email', reason);
        prepareNative('[BACKUP COPY: HubSpot did not accept this submission, re-enter it manually]');
        if (typeof form.submit === 'function') form.submit();
      };

      const buildPayload = () => {
        const fields = [];
        const multi = {};
        form.querySelectorAll('[data-hs]').forEach((el) => {
          const name = el.dataset.hs;
          if (!name) return;
          if (el.type === 'checkbox') {
            if (el.hasAttribute('data-hs-multi')) {
              if (!multi[name]) multi[name] = [];
              if (el.checked) multi[name].push(el.value);
            } else if (el.hasAttribute('data-hs-bool')) {
              fields.push({ objectTypeId: '0-1', name, value: el.checked ? 'true' : 'false' });
            } else if (el.checked) {
              fields.push({ objectTypeId: '0-1', name, value: el.value });
            }
            return;
          }
          if (el.type === 'radio') {
            if (el.checked) fields.push({ objectTypeId: '0-1', name, value: el.value });
            return;
          }
          const value = (el.value || '').trim();
          if (value) fields.push({ objectTypeId: '0-1', name, value });
        });
        Object.keys(multi).forEach((name) => {
          if (multi[name].length) fields.push({ objectTypeId: '0-1', name, value: multi[name].join(';') });
        });

        const payload = {
          submittedAt: Date.now(),
          fields,
          context: {
            pageUri: window.location.href,
            pageName: document.title,
          },
        };
        const hutk = readCookie('hubspotutk');
        if (hutk) payload.context.hutk = hutk;

        const consent = form.querySelector('[data-hs-consent]');
        const notice = form.querySelector('[data-hs-consent-notice]');
        if (notice || (consent && consent.checked)) {
          const text = notice || consent.closest('.evt-check');
          const consentText = text ? text.textContent.replace(/\s+/g, ' ').trim() : 'Consent to contact';
          const subscriptionId = parseInt(form.dataset.hsSubscription, 10);
          payload.legalConsentOptions = {
            consent: {
              consentToProcess: true,
              text: consentText,
              communications: Number.isFinite(subscriptionId)
                ? [{ value: true, subscriptionTypeId: subscriptionId, text: consentText }]
                : [],
            },
          };
        }
        return payload;
      };

      const showInline = () => {
        if (body) body.hidden = true;
        if (success) {
          success.hidden = false;
          success.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
      };
      // Redirect only if the thank-you page actually exists; otherwise fall
      // back to the inline confirmation instead of sending people to a 404
      const goNext = (next, replace) => fetch(next, { method: 'HEAD', credentials: 'same-origin' })
        .then((r) => { if (r.ok) { replace ? window.location.replace(next) : window.location.assign(next); } else { showInline(); } })
        .catch(showInline);
      const showSuccess = () => {
        document.dispatchEvent(new CustomEvent('evt:registered', { detail: { form } }));
        const next = form.dataset.successUrl;
        if (next) { goNext(next, false); return; }
        showInline();
      };

      form.addEventListener('submit', (event) => {
        const firstMissing = validate();
        if (firstMissing) {
          event.preventDefault();
          showError(form.dataset.errorText);
          firstMissing.focus({ preventScroll: false });
          return;
        }

        celebrate();
        const portal = form.dataset.hsPortal;
        const guid = form.dataset.hsGuid;
        if (!portal || !guid) {
          // No HubSpot form configured: native Shopify contact submit
          prepareNative('');
          return;
        }

        event.preventDefault();
        hideError();
        if (submit) submit.disabled = true;

        // Test switch: ?evt_test=backup skips HubSpot and exercises the email
        // backup route end to end from a real browser (captcha included)
        if (new URLSearchParams(window.location.search).get('evt_test') === 'backup') {
          nativeBackup('forced by ?evt_test=backup');
          return;
        }

        const host = form.dataset.hsHost || 'api.hsforms.com';
        const endpoint = 'https://' + host + '/submissions/v3/integration/submit/' + portal + '/' + guid;

        const payload = JSON.stringify(buildPayload());
        const attempt = () => fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: payload,
        });
        const wait = (ms) => new Promise((resolve) => window.setTimeout(resolve, ms));
        const handle = (response, isRetry) => response.json().catch(() => null).then((data) => {
          if (response.ok) {
            clearDraft();
            if (data && data.redirectUri) { window.location.assign(data.redirectUri); return; }
            showSuccess();
            return;
          }
          // 400 = HubSpot rejected the content (bad email, invalid option): the
          // registrant can fix that, so show the message and keep the answers
          if (response.status === 400) {
            console.warn('[event-registration] HubSpot rejected the submission', data);
            const detail = data && data.errors && data.errors.length ? data.errors.map((e) => e.errorType || e.message).join(', ') : response.status;
            showError((form.dataset.networkText || 'Something went wrong. Please try again.') + ' (' + detail + ')');
            if (submit) submit.disabled = false;
            return;
          }
          // 429 rate limit, 5xx outage, 403/404 misconfiguration: retry once,
          // then fall back to the email backup so nothing is lost
          if (!isRetry) return wait(1500).then(attempt).then((r) => handle(r, true));
          nativeBackup('HTTP ' + response.status);
        });
        attempt()
          .then((r) => handle(r, false))
          .catch((error) => {
            if (!window.navigator.onLine) {
              showError(form.dataset.networkText || 'Something went wrong. Please try again.');
              if (submit) submit.disabled = false;
              return;
            }
            return wait(1500).then(attempt).then((r) => handle(r, true)).catch((err) => nativeBackup(err));
          });
      });

      // External links in rich-text settings open in a new tab (the editor can strip target)
      document.querySelectorAll('.evt__venue-info a[href^="http"], .evt__rte a[href^="http"]').forEach((a) => {
        a.target = '_blank';
        a.rel = 'noopener';
      });

      // Sunset confetti on the submit button: a burst on hover, a volley on
      // submit (same particles and palette as the About page closing card)
      const confettiHost = form.closest('.evt__form-card');
      let celebrate = () => {};
      if (confettiHost && submit && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const COLORS = ['#d6aedd', '#90dff9', '#fbe8a7', '#f69d25', '#e7d49d', '#e2f4fe'];
        const canvas = document.createElement('canvas');
        canvas.className = 'evt__form-confetti';
        canvas.setAttribute('aria-hidden', 'true');
        confettiHost.appendChild(canvas);
        const ctx = canvas.getContext('2d');
        const dpr = Math.min(window.devicePixelRatio || 1, 2);
        const resize = () => {
          canvas.width = confettiHost.clientWidth * dpr;
          canvas.height = confettiHost.clientHeight * dpr;
        };
        resize();
        if ('ResizeObserver' in window) new ResizeObserver(resize).observe(confettiHost);

        let particles = [];
        let raf = 0;
        const tick = () => {
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          particles = particles.filter((pt) => pt.age < pt.ttl);
          for (const pt of particles) {
            pt.age += 1;
            pt.vx *= pt.drag;
            pt.vy = pt.vy * pt.drag + pt.gravity;
            pt.x += pt.vx;
            pt.y += pt.vy;
            pt.rotation += pt.spin;
            ctx.globalAlpha = 1 - pt.age / pt.ttl;
            ctx.save();
            ctx.translate(pt.x, pt.y);
            ctx.rotate(pt.rotation);
            ctx.fillStyle = pt.color;
            ctx.fillRect(-pt.width / 2, -pt.height / 2, pt.width, pt.height);
            ctx.restore();
          }
          ctx.globalAlpha = 1;
          if (particles.length) {
            raf = requestAnimationFrame(tick);
          } else {
            raf = 0;
            ctx.clearRect(0, 0, canvas.width, canvas.height);
          }
        };
        const spawn = (x, y, count, power) => {
          for (let i = 0; i < count; i += 1) {
            const angle = Math.random() * Math.PI * 2;
            const speed = (1.5 + Math.random() * power) * dpr;
            particles.push({
              x: x * dpr,
              y: y * dpr,
              vx: Math.cos(angle) * speed,
              vy: Math.sin(angle) * speed - 1.2 * dpr,
              gravity: 0.055 * dpr,
              drag: 0.986,
              width: (2.5 + Math.random() * 3.5) * dpr,
              height: (5 + Math.random() * 5) * dpr,
              rotation: Math.random() * Math.PI,
              spin: (Math.random() - 0.5) * 0.28,
              age: 0,
              ttl: 70 + Math.random() * 55,
              color: COLORS[(Math.random() * COLORS.length) | 0],
            });
          }
          if (!raf) raf = requestAnimationFrame(tick);
        };
        const buttonPoint = () => {
          const host = confettiHost.getBoundingClientRect();
          const b = submit.getBoundingClientRect();
          return { x: b.left - host.left + b.width / 2, y: b.top - host.top + b.height / 2, w: b.width };
        };
        let lastHover = 0;
        submit.addEventListener('pointerenter', () => {
          const now = performance.now();
          if (now - lastHover < 900) return;
          lastHover = now;
          const c = buttonPoint();
          spawn(c.x - c.w * 0.25, c.y, 14, 3.4);
          spawn(c.x + c.w * 0.25, c.y, 14, 3.4);
        });
        celebrate = () => {
          const c = buttonPoint();
          [-0.35, 0, 0.35, -0.18, 0.18].forEach((fx, i) => {
            window.setTimeout(() => spawn(c.x + c.w * fx, c.y, 26, 4.5), i * 120);
          });
        };
      }

      // Sticky form card: pin by the top when it fits the viewport, otherwise
      // pin by the bottom so the submit button stays in view while the event
      // details scroll past on the left
      const card = form.closest('.evt__form-card');
      if (card) {
        const place = () => {
          const headerH = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-group-height')) || 0;
          const gap = 16;
          const fitsTop = headerH + gap;
          const bottomPinned = window.innerHeight - card.offsetHeight - gap;
          card.style.setProperty('--evt-sticky-top', Math.min(fitsTop, bottomPinned) + 'px');
        };
        place();
        window.addEventListener('resize', place);
        if ('ResizeObserver' in window) new ResizeObserver(place).observe(card);
      }

      // Native fallback posted: go to the thank-you page when one is set,
      // otherwise bring the inline confirmation into view and clean the URL
      if (success && !success.hidden) {
        window.history.replaceState(null, '', window.location.pathname);
        if (form.dataset.successUrl) {
          goNext(form.dataset.successUrl, true);
          return;
        }
        success.scrollIntoView({ block: 'center' });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onboarding-guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const punch = document.querySelector('[data-punch]');
    if (!punch) return;

    const items = Array.from(punch.querySelectorAll('[data-punch-item]'));
    const countEl = punch.querySelector('[data-punch-count]');
    const fillEl = punch.querySelector('[data-punch-fill]');
    const celebrate = punch.querySelector('[data-punch-celebrate]');
    const key = 'ceeattle-onboarding-' + (window.location.pathname || 'guide');

    let saved = {};
    try {
      saved = JSON.parse(localStorage.getItem(key) || '{}');
    } catch (e) {
      saved = {};
    }

    const render = () => {
      let done = 0;
      let nextMarked = false;
      items.forEach((input) => {
        const li = input.closest('.onboarding-guide__task');
        li.removeAttribute('data-next');
        if (input.checked) {
          done += 1;
        } else if (!nextMarked) {
          li.setAttribute('data-next', '');
          nextMarked = true;
        }
      });
      if (countEl) countEl.textContent = done;
      if (fillEl) fillEl.style.width = (done / items.length) * 100 + '%';
      if (celebrate) celebrate.hidden = done !== items.length;
    };

    items.forEach((input) => {
      if (saved[input.value]) input.checked = true;
      input.addEventListener('change', () => {
        saved[input.value] = input.checked;
        try {
          localStorage.setItem(key, JSON.stringify(saved));
        } catch (e) {
          /* private mode: progress just won't persist */
        }
        render();
      });
    });

    render();
  })();

  } catch(e) { console.error(e); }
})();
})();
